import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Positioning from './components/Positioning';
import WhoWeWorkWith from './components/WhoWeWorkWith';
import OurApproach from './components/OurApproach';
import WhatMakesDifferent from './components/WhatMakesDifferent';
import TheOutcome from './components/TheOutcome';
import TrustSection from './components/TrustSection';
import FinalCTA from './components/FinalCTA';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0B0D10]">
      <Navbar />
      <Hero />
      <Positioning />
      <WhoWeWorkWith />
      <OurApproach />
      <WhatMakesDifferent />
      <TheOutcome />
      <TrustSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}